/* eslint-disable no-case-declarations */
import React, {
  memo, useState, useEffect,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';
import {
  StatusDropdown, StatusBox, InputInside, 
  // CheckMark,
} from 'components';
import {
  applicantDetailById, applicantMoStatus, saveApplicantMoStatus, toggleCRNActionWithApi,
} from 'shared/context/actions';
import connect from 'shared/context/connect';
import { CONST_RETAIL_APPLICANT } from 'shared/constants';
import Retail from './Retail';
import Qualified from './Qualified';

import './styles/FormsApp.scss';

interface Props {
  phone?: string,
  onGetApplicantDetailById,
  onGetApplicantMoStatus,
  onSaveApplicantMoStatus,
  data?:any
  isSigned?:boolean
  onUpdateData,
  onUpdateInput,
  applicantStatus?:any,
  isQualifield?:boolean,
  assetAllocationAvailable?:boolean,
  isNeitherRetailNorQualified?:boolean,
  isFirstOneSigned?:boolean,
  isCRNsaved?:boolean,
  onToggleCRNAction?
  onUpdateStatus,
  detail?
  crn?:string,
  onUpdateCRN?: (value:string)=>void,
  clientDetail?,
  languageRemote,
  isDisabled?: boolean,
  paymentData: any
}

const mutualFundMagicMap = {
  'NW-MAR-CLA-POR': 'KW0EQ0903298',
  'NW-MAR-CLA-MUT': 'KW0EQ0903314',
  'NW-MAR-CLA-RE': 'KW0EQ0901367',
};

const FormsApp: React.FC<Props> = memo(({
  data = null,
  isSigned = false,
  onUpdateData = () => {},
  onUpdateInput = () => {},
  applicantStatus = null,
  isCRNsaved = false,
  isQualifield = false,
  isNeitherRetailNorQualified = true,
  // assetAllocationAvailable = false,
  isFirstOneSigned = false,
  onUpdateStatus = () => {},
  onToggleCRNAction = () => {},
  detail = {},
  crn,
  onUpdateCRN = () => {},
  clientDetail,
  languageRemote,
  isDisabled,
  paymentData,
}) => {
  // const {} = props;

  const intl = useIntl();

  const {
    SELECT_BOX: { APPROVE, REWORK },
    STATUS: {
      PARTIAL, COMPLETE, APPROVED, REWORKED,
    }, DROPDOWN: {
      COMPLETED,
    },
  } = CONST_RETAIL_APPLICANT;
  const [state, setState] = useState(data);
  const [typeOfinvestment, setTypeOfinvestment] = useState(null);
  const [typeOfinvestmentInfo, setTypeOfinvestmentInfo] = useState(null);

  useEffect(() => {
    setState(data);
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (languageRemote && clientDetail) {
      if (isQualifield) {
        const typeOE = languageRemote.options.qualifiedTypeOfInvestmentOptions.find((p) => p.id === clientDetail.typeOfInvestment);
        if (!typeOE) {
          return;
        }
        const { label } = typeOE;
        const typeString = languageRemote.languages.EN[label];
        switch (typeOE.id) {
          case 'NW-MAR-CLA-MFT':
            // eslint-disable-next-line no-case-declarations
            let { product } = clientDetail;
            if (mutualFundMagicMap[product]) {
              product = mutualFundMagicMap[product];
            }
            // eslint-disable-next-line no-case-declarations
            const productOptional = languageRemote.options.productOptions.find((p) => p.id === product);
            const productLabel = productOptional ? productOptional.label : '';
            setTypeOfinvestment(typeString);
            setTypeOfinvestmentInfo(languageRemote.languages.EN[productLabel]);
            break;
          case 'NW-MAR-CLA-DIS':
            const { investmentStrategies } = clientDetail;
            let final = '';
            investmentStrategies.forEach((p) => {
              // eslint-disable-next-line max-len
              const labOptional = languageRemote.options.investmentStrategyOptions.find((k) => k.id === p);
              const lab = labOptional ? labOptional.label : '';
              final += `${languageRemote.languages.EN[lab]},`;
            });
            setTypeOfinvestment(typeString);
            setTypeOfinvestmentInfo(final.slice(0, -1));

            break;
          case 'NW-MAR-CLA-NDIS':
          // eslint-disable-next-line no-case-declarations
            const { assetAllocations } = clientDetail;
            // eslint-disable-next-line no-case-declarations
            const assetAllocationOptional = languageRemote.options.assetAllocationOptions.find((p) => p.id === assetAllocations);
            const assetAllocationsLabel = assetAllocationOptional ? assetAllocationOptional.label : '';
            // setTypeOfinvestment(`${typeString} with ${languageRemote.languages.EN[assetAllocationsLabel]}`);
            setTypeOfinvestment(typeString);
            setTypeOfinvestmentInfo(languageRemote.languages.EN[assetAllocationsLabel]);
            break;
          default:
            setTypeOfinvestment(`${typeString}`);
            break;
        }
      } else {
        const typeOE = languageRemote.options.typeOfInvestmentOptions.find((p) => p.id === clientDetail.typeOfInvestment);
        if (!typeOE) {
          return;
        }
        const { label } = typeOE;
        const typeString = languageRemote.languages.EN[label];

        switch (typeOE.id) {
          case 'NW-MAR-IEY-MUT':
            // eslint-disable-next-line no-case-declarations
            let { product } = clientDetail;
            if (mutualFundMagicMap[product]) {
              product = mutualFundMagicMap[product];
            }
            // eslint-disable-next-line no-case-declarations
            const productOptional = languageRemote.options.productOptions.find((p) => p.id === product || p.isin === product);
            const productLabel = productOptional ? productOptional.label : '';
            setTypeOfinvestment(typeString);
            setTypeOfinvestmentInfo(languageRemote.languages.EN[productLabel]);
            break;
          default:
            setTypeOfinvestment(`${typeString}`);
            break;
        }
        // console.log('languageRemote languageRemote zzz 1', languageRemote.options.qualifiedTypeOfInvestmentOptions, clientDetail.typeOfInvestment);

      // console.log('languageRemote languageRemote zzz 2', [clientDetail.typeOfInvestment]);
      }
    }
  }, [languageRemote, clientDetail, isQualifield]);

  const [isSign, setIsSign] = useState(isSigned);
  useEffect(() => {
    setIsSign(isSigned);
    // eslint-disable-next-line
  }, [isSigned]);

  //* * hiden : show */
  const [showAdminStatus, setShowAdminStatus] = useState(false);
  const [showResultStatus, setShowResultStatus] = useState(false);
  const [showAgreements, setShowAgreements] = useState(false);
  const [showResultAgreements, setShowResultAgreements] = useState(false);
  // const [showAdminStatusQualified, setShowAdminStatusQualified] = useState(true);

  //* * INPUT APPLICANT STATUS*/
  const [inputValue, setInputValue] = useState({
    isFocus: false,
    vestioId: applicantStatus.vestioId,
    comment: applicantStatus.comment,
  });
  useEffect(() => {
    setInputValue({
      ...inputValue,
      vestioId: applicantStatus.vestioId,
      comment: applicantStatus.comment,
    });
    // eslint-disable-next-line
  }, [applicantStatus]);
  const handleInputChange = (name, value) => {
    const dataUpdate = { [name]: value };
    setInputValue({
      ...inputValue,
      ...dataUpdate,
    });
    onUpdateInput({ ...dataUpdate });
  };

  //* *  statusApplicantForms STATUS */
  useEffect(() => {
    if (state !== null) {
      const appSta = state.crmFatcaCrs && state.crmFatcaCrs.applicantForms && state.crmFatcaCrs.applicantForms.status;
      const adminSta = state.crmFatcaCrs && state.crmFatcaCrs.adminStatus && state.crmFatcaCrs.adminStatus.status;
      const adminAgreementsSta = state && state.agreements.adminStatus && state.agreements.adminStatus.status;
      if (appSta === COMPLETE || appSta === COMPLETED) {
        // console.log('appSta', appSta);
        setShowAdminStatus(true);
        if (!isFirstOneSigned) {
          setShowAgreements(true);
        }
      }
      if (adminSta === APPROVED) {
        setShowResultStatus(true);
      }
      if (adminAgreementsSta === APPROVED) {
        setShowResultAgreements(true);
      }
    }
    // eslint-disable-next-line
  }, [state]);

  useEffect(() => {
    // console.log('isQualifield', isQualifield);
    if (isQualifield) {
      // setShowAgreements(true);
    }
  }, [isQualifield]);

  //* *  handle admin status*/
  const handleChangeAdminStatus = (val) => {
    const isOk = !!(val === APPROVED || val === APPROVE);
    const dataUpdate = {
      ...state,
      crmFatcaCrs: {
        ...state.crmFatcaCrs,
        applicantForms: {
          ...state.crmFatcaCrs.applicantForms,
          status: !isOk ? val : state.crmFatcaCrs.applicantForms.status,
          statusDetail: moment().toDate().getTime(),
        },
        adminStatus: {
          ...state.crmFatcaCrs.adminStatus,
          status: isOk ? val : REWORKED,
        },
        result: {
          ...state.crmFatcaCrs.result,
          statusDetail: isOk ? moment().toDate().getTime() : null,
        },
      },
    };
    setState(dataUpdate);
    onUpdateData(dataUpdate);
    if (isOk) {
      setShowResultStatus(true);
    } else {
      setShowAdminStatus(false);
      setShowResultStatus(false);
      setShowAgreements(false);
    }
  };

  //* *  handle Agreements status*/
  const handleChangeAgreementsStatus = (val) => {
    const isOk = !!(val === APPROVED || val === APPROVE);
    const dataUpdate = {
      ...state,
      agreements: {
        ...state.agreements,
        adminStatus: {
          ...state.agreements.adminStatus,
          status: val,
          statusDetail: isOk ? moment().toDate().getTime() : null,
        },
        result: {
          ...state.agreements.result,
          statusDetail: isOk ? moment().toDate().getTime() : null,
          status: null,
        },
      },
    };
    setState(dataUpdate);
    onUpdateData(dataUpdate);
    if (isOk) {
      setShowResultAgreements(true);
    } else {
      setShowResultAgreements(false);
    }
  };

  //* *  handle Change Application Status*/
  const handleChangeApplicationStatus = (value) => {
    const dataUpdate = {
      ...state,
      overallStatus: value,
    };
    setState(dataUpdate);
    // onUpdateData(dataUpdate);
    onUpdateStatus(value);
    // if (value === COMPLETED) {
    //   // const inputUpdate = {
    //   vestioId: '',
    //   comment: '',
    // };
    // setInputValue({ ...inputUpdate, isFocus: true });
    // onUpdateInput({ ...inputUpdate });
    // setInputValue({ ...inputValue, isFocus: true });
    // onUpdateInput({ ...inputValue });
    // }
    // else {
    //   setInputValue({
    //     isFocus: false,
    //     vestioId: applicantStatus.vestioId,
    //     comment: applicantStatus.vestioId,
    //   });
    // }
  };

  //* *  get Label data*/
  const getLabelDate = (status, isQualifield) => {
    if (!status) {
      return null;
    }
    switch (status.toLowerCase()) {
      case REWORK.toLowerCase():
        return 'manageApplication.ApplicationReOpenOn';
      case PARTIAL.toLowerCase():
        return 'manageApplication.lastUpdatedOn';
      case COMPLETED.toLowerCase():
        return isQualifield ? 'manageApplication.approvedOn' : 'manageApplication.completedOn';
      case COMPLETE.toLowerCase():
        return 'manageApplication.completedOn';
      case APPROVED.toLowerCase():
        return 'manageApplication.approvedOn';
      default:
        return null;
    }
  };

  if (state === null) {
    return (
      <div>
        Loading...
      </div>
    );
  }
  let title = 'manageApplication.overallApplicationStatusNone';
  if (!isNeitherRetailNorQualified) {
    title = isQualifield ? 'manageApplication.overallApplicationStatusQualified' : 'manageApplication.overallApplicationStatusRetail';
  }

  const date = state && state.crmFatcaCrs && state.crmFatcaCrs.applicantForms && state.crmFatcaCrs.applicantForms.statusDetail;
  const crmFatcaCrsStatus = state && state.crmFatcaCrs && state.crmFatcaCrs.applicantForms && state.crmFatcaCrs.applicantForms.status;
  const statusFormDetailCrmFatcaCrs = date ? (
    <FormattedMessage

      id={
        getLabelDate(crmFatcaCrsStatus, isQualifield)
      }
      values={{
        b: (...chunks) => <b>{chunks}</b>,
        date: moment(state.crmFatcaCrs.applicantForms.statusDetail).format('DD MMM YYYY'),
      }}
    />
  )
    : null;
  const adminStatus = state && state.crmFatcaCrs && state.crmFatcaCrs.adminStatus;
  const agreementAdminStatus = state && state.agreements && state.agreements.adminStatus;

  // console.log('detail 121321', detail);
  return (
    <div className="formsApp">
      <div className="formsApp__titleStatus">
        <h3>
          <FormattedMessage
            id={title}
            values={{
              span: (...chunks) => <span>{chunks}</span>,
            }}
          />
        </h3>
        <StatusDropdown
          defaultValue={state.overallStatus}
          onSelectChange={handleChangeApplicationStatus}
        />
      </div>
      <div className="formsApp__investment">
        <span>{typeOfinvestment}</span>
        {typeOfinvestmentInfo && (
        <>
          <span style={{ opacity: '0.5' }}> with </span>
          <span>{typeOfinvestmentInfo}</span>
        </>
        )}
        {Object.keys(paymentData).length ? (
          <span>
            {' '}
            |
            {' '}
            <strong>KNET payment status: </strong>
            {' '}
            {paymentData?.status}
          </span>
        ) : null}
      </div>
      <div className="formsApp__content">
        <h4>CRM, FATCA & CRS</h4>

        <div className="formsApp__content__list">
          {/* applicantForms */}
          <div className="formsApp__content__list__item">
            <StatusBox
              title={state.crmFatcaCrs.applicantForms.title}
              status={crmFatcaCrsStatus}
              isShowDate
              statusDetail={statusFormDetailCrmFatcaCrs}
            />
          </div>

          {/* adminStatus */}
          {showAdminStatus && (
            <>
              <div className="formsApp__content__list__item isChild">
                <StatusBox
                  title={adminStatus && adminStatus.title}
                  status={adminStatus && adminStatus.status}
                  onStatusChange={handleChangeAdminStatus}
                  isDropdown={showAdminStatus}
                  isDisabled={isDisabled}
                  statusDetail={adminStatus
                  && adminStatus.statusDetail !== null ? (
                    <FormattedMessage
                      key="manageApplication.completedOn"
                      id="manageApplication.completedOn"
                      values={{
                        b: (...chunks) => <b>{chunks}</b>,
                        date: moment(adminStatus && adminStatus.statusDetail).format('DD MMM YYYY'),
                      }}
                    />
                    ) : null}
                />
              </div>
            </>
          )}
          {/* result */}
          {showResultStatus && (
            <div className="formsApp__content__list__item isChild">
              <StatusBox
                isSuccess
                isDropdown
                isDisabled={isDisabled}
                statusDetail={(
                  <FormattedMessage
                    key="manageApplication.ApprovedOnBy-key"
                    id="manageApplication.ApprovedOnBy"
                    values={{
                      span: (...chunks) => <span>{chunks}</span>,
                      b: (...chunks) => <b>{chunks}</b>,
                      date: moment(state.crmFatcaCrs.result.statusDetail).format('DD MMM YYYY'),
                      user: state.crmFatcaCrs.result.updatedBy,
                    }}
                  />
                    )}
              />
            </div>
          )}
        </div>

        {/* ========= AGREEMENTS ========= */}

        {showAgreements && (
        <>
          <h4>AGREEMENTS</h4>
          {isQualifield ? (
            (!crmFatcaCrsStatus || REWORK.toLowerCase() !== crmFatcaCrsStatus.toLowerCase()) && (
            <Qualified
              isCRNsaved={isCRNsaved}
              agreements={state.agreements}
              handleChangeAgreementsStatus={handleChangeAgreementsStatus}
              handleChangeAdminStatus={handleChangeAdminStatus}
              labelTransID={getLabelDate(agreementAdminStatus && agreementAdminStatus.status, isQualifield)}
              isSign={isSign}
              isCustomCrn={detail.customCrn}
              isDisabled={isDisabled}
            />
            )
          ) : (
            <Retail
              agreements={state.agreements}
              overallStatus={state.overallStatus}
              handleChangeAgreementsStatus={handleChangeAgreementsStatus}
              handleChangeAdminStatus={handleChangeAdminStatus}
              showResultAgreements={showResultAgreements}
              labelTransID={getLabelDate(crmFatcaCrsStatus, false)}
              isSign={isSign}
              isDisabled={isDisabled}
            />
          )}
        </>
        )}
      </div>
      <div className="formsApp__form">
        {isQualifield && (
          <>
            {/* <div className="formsApp__form__check">
              <CheckMark
                id="item.id"
                label={intl.formatMessage({ id: 'crnCheckMarkLabel' })}
                onCheckMarkChange={() => {
                  onToggleCRNAction(!detail.customCrn);
                }}
                isChecked={detail.customCrn}
                isDisabled={isDisabled}
              />
              { detail.customCrn && (
              <InputInside
                name="crn"
                label={intl.formatMessage({ id: 'crn' })}
                value={crn}
                isCustomInput
                onInputChange={onUpdateCRN}
                disabled={isDisabled}
              />
              )}
            </div> */}
            <InputInside
              name="crn"
              label={intl.formatMessage({ id: 'crn' })}
              value={crn}
              isCustomInput
              onInputChange={onUpdateCRN}
              disabled={true}
              />
          </>
        )}
        <InputInside
          // disabled={state.overallStatus !== COMPLETED}
          isFocus={state.overallStatus === COMPLETED}
          label={intl.formatMessage({ id: 'dashboard.updateApp.vestioId' })}
          name="vestioId"
          value={inputValue.vestioId === null ? '' : inputValue.vestioId}
          onInputChange={handleInputChange}
          disabled={isDisabled}
        />
        <InputInside
          // disabled={state.overallStatus !== COMPLETED}
          name="comment"
          label={intl.formatMessage({ id: 'dashboard.updateApp.cmtByMarkaz' })}
          value={inputValue.comment === null ? '' : inputValue.comment}
          onInputChange={handleInputChange}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
});
const mapStateToProps = ({ dashboard }) => ({
  detail: dashboard.detail,
  languageRemote: dashboard.languageRemote,
});

const mapDispatchToProps = ({
  onGetApplicantDetailById: applicantDetailById,
  onGetApplicantMoStatus: applicantMoStatus,
  onSaveApplicantMoStatus: saveApplicantMoStatus,
  onToggleCRNAction: toggleCRNActionWithApi,
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(FormsApp));
